import React, { useContext, useEffect } from "react";
import { Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import { context } from "./../../context/context";
import config from "../../services/config.json";
import { http } from "./../../services/httpService";

const AddMedia = () => {
    // context
    const {
        fileList,
        setFileList,
        coverPic,
        setCoverPic,
        setCoverPicId,
        setFileListIds,
        fileListIds,
        placeId,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        http.get(`${config.parkopoloApi}/api/Place/gallery/${placeId}`)
            .then((res) => {
                setCoverPicId(res.data.result.coverPic._id);

                const ids = [];
                const files = [];
                res.data.result.media.map((file) => {
                    ids.push(file._id);
                    files.push({
                        uid: file._id,
                        name: `${file.type}/${file._id}`,
                        status: "done",
                        url: file.address,
                    });
                });
                setFileListIds(ids);
                setFileList(files);
                setCoverPic([
                    {
                        uid: res.data.result.coverPic._id,
                        name: "image.png",
                        status: "done",
                        url: res.data.result.coverPic.address,
                    },
                ]);
            })
            .catch((err) => console.log(err));
    }, []);
    // upload
    const onChangeCover = (info) => {
        setCoverPic(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            setCoverPicId(info.file.response.files[0]._id);
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onChange = (info) => {
        setFileList(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            info.file.response.files.map((file) => {
                setFileListIds([...fileListIds, file._id]);
            });
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };
    const handleRemove = (info) => {
        const newFiles = fileList.filter((file) => file !== info);
        const newIds = fileListIds.filter((id) => id !== info.uid);
        setFileListIds(newIds);
        setFileList(newFiles);
    };
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                padding: "2rem 0",
                gap: "2rem",
            }}
        >
            <ImgCrop rotationSlider aspect={2} modalTitle="ویرایش عکس">
                <Upload
                    maxCount={1}
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=658a8d6096f6a0a56ce475b7`}
                    listType="picture-card"
                    fileList={coverPic}
                    onChange={onChangeCover}
                    onPreview={onPreview}
                >
                    {coverPic.length < 5 && "+ آپلود عکس کاور"}
                </Upload>
            </ImgCrop>
            <ImgCrop rotationSlider modalTitle="ویرایش عکس">
                <Upload
                    accept="image/*"
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=658a926a96f6a0a56ce47a53`}
                    listType="picture-card"
                    fileList={fileList}
                    onChange={onChange}
                    onPreview={onPreview}
                    onRemove={handleRemove}
                >
                    {coverPic.length < 3 && "+ آپلود عکس"}
                </Upload>
            </ImgCrop>
            <Upload
                accept="video/*"
                multiple={false}
                name="objectKey"
                action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=658a926a96f6a0a56ce47a53`}
                listType="picture-card"
                fileList={fileList}
                onChange={onChange}
                onPreview={onPreview}
                onRemove={handleRemove}
            >
                {coverPic.length < 3 && "+ آپلود ویدیو"}
            </Upload>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    flexWrap: "wrap",
                    gap: "2rem",
                }}
            >
                {fileList.map((media) => {
                    if (media.name && media.name.slice(0, 5) === "video") {
                        return (
                            <video
                                src={media.url}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    } else if (
                        media.type &&
                        media.type.slice(0, 5) === "video"
                    ) {
                        return (
                            <video
                                src={media.response?.files[0].address}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    }
                })}
            </div>
        </div>
    );
};

export default AddMedia;
